module.exports = __webpack_public_path__ + "static/media/state_of_art.03261356.svg";